import React from "react";

const OffersIcon = ({ fill = "#387CFF", stroke = "#387CFF", ...props }) => (
  <svg
    width="19"
    height="19"
    viewBox="0 0 18 18"
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    {...props} // Spread additional props (e.g., className, style)
  >
    
    <path
      d="M15.587 8.706L9.287 2.406C9.035 2.154 8.685 2 8.3 2H3.4C2.63 2 2 2.63 2 3.4V8.3C2 8.685 2.154 9.035 2.413 9.294L8.713 15.594C8.965 15.846 9.315 16 9.7 16C10.085 16 10.435 15.846 10.687 15.587L15.587 10.687C15.846 10.435 16 10.085 16 9.7C16 9.315 15.839 8.958 15.587 8.706ZM9.7 14.607L3.4 8.3V3.4H8.3V3.393L14.6 9.693L9.7 14.607Z"
      fill={fill} // Allow dynamic fill color
    />
    <path
      d="M5 6C5.55228 6 6 5.55228 6 5C6 4.44772 5.55228 4 5 4C4.44772 4 4 4.44772 4 5C4 5.55228 4.44772 6 5 6Z"
      fill={fill} // Allow dynamic fill color
    />
  </svg>
);

export default OffersIcon;
